import React, { ReactNode } from 'react'
import { majorScale, Pane, Spinner } from 'evergreen-ui'

interface LoadingPlaceholderProps {
  children?: ReactNode
  /** How long to wait before showing the spinner */
  delay?: number
  /** Whether or not to show the loading placeholder or the children */
  isLoading?: boolean
  /** Whether or not to apply default padding */
  noPadding?: boolean
}

class LoadingPlaceholder extends React.Component<LoadingPlaceholderProps & React.ComponentProps<typeof Pane>> {
  static defaultProps = {
    isLoading: false,
    noPadding: false
  }

  render() {
    const { children = null, delay, isLoading, noPadding, ...props } = this.props
    const size = majorScale(3)

    if (isLoading) {
      return (
        <Pane display="flex" minHeight={size} paddingY={noPadding ? 0 : majorScale(8)} flex={1} {...props}>
          <Spinner delay={delay} size={size} flexBasis={size} marginX="auto" />
        </Pane>
      )
    }

    return children
  }
}

export default LoadingPlaceholder
